module.exports = __webpack_public_path__ + "img/tag-1.86d4fa5f.svg";